// extracted by mini-css-extract-plugin
export default {"MinMaxValuation":"min-max-valuation_MinMaxValuation__MN860"};